export const Color = {
  jaune: "#FCAE3B",
  bleu: "#28348a",
  vert: "#1AA981",
  themeColor: "#994B34",
  rouge: "#E73628",
  success: "#1AA981",
  default: "#2a71d5",
  danger: "#E73628",
};

export const Font = {
  family: "#Montserrat",
};